/**
 * Check if the provided URL is external.
 *
 * @param url The URL to check.
 * @returns True if the URL is external, false otherwise.
 */
export function isExternalLink(url: string | undefined): boolean {
    // If URL doesn't exist, return false.
    if (!url) {
        return false;
    }

    // Check for absolute links.
    return (
        url.startsWith('http://') ||
        url.startsWith('https://') ||
        url.startsWith('mailto:') ||
        url.startsWith('tel:') ||
        url.startsWith('/file')
    );
}
